import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  NgbModal,
  NgbModalConfig,
  NgbModalRef,
  NgbOffcanvas,
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
// import moment from "moment";
import { DOCUMENT } from "@angular/common";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators
} from "@angular/forms";
import {
  EventApi,
  EventClickArg
} from "@fullcalendar/angular";
import { DataTableDirective } from "angular-datatables";
import * as _ from "lodash";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { Subject, Subscription, forkJoin } from "rxjs";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { AppAliasService } from "src/app/core/services/app-alias.service";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { EmployeeListService } from "src/app/core/services/employees/employee-list.service";
import { JobTypeService } from "src/app/core/services/employees/job-type/job-type.service";
import { locationBroadcastService } from "src/app/core/services/loaction-broadcast.service";
import { LocationsService } from "src/app/core/services/locations/locations.service";
import { PermissionService } from "src/app/core/services/permission.service";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { AppState } from "src/app/store/app.state";
import { setLoadingSpinner } from "src/app/store/sharedstate/shared.actions";
// import { ApiService } from "./../../../services/api";
// import { TimezoneService } from "./../../../services/timezone";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';
// import { SimpleUploadAdapter } from 'ckeditor5';
// import Base64UploadAdapter from "@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter";
import { BlurEvent, ChangeEvent, FocusEvent } from "@ckeditor/ckeditor5-angular";
import { TranslatePipe } from "src/app/core/pipes/translate.pipe";
import Adapter from "src/app/core/services/ckeditorAdapter";
import { ApiService } from "src/app/services/api";
import { TimezoneService } from "src/app/services/timezone";
import { SupportPinService } from "src/app/core/services/support-pin/support-pin.service";

@Component({
  selector: 'app-support-tickets',
  templateUrl: './support-tickets.component.html',
  styleUrls: ['./support-tickets.component.scss'],
  providers: [TranslatePipe],
})

export class SupportTicketsComponent implements OnInit {

  @ViewChild("reset2faContent") reset2faContent;

    private dataSubscription: Subscription = null;

    private Timezone:any = this.timezoneService.get()

    // Load the CKEditor
    public Editor = ClassicEditor;
    public editorContent: string = ''; // CKEditor content
    // ckconfig;
    public componentEvents: string[] = [];
    editorConfig = {
      placeholder: 'Please Describe the Issue...',
      toolbar: ['heading', '|', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'imageUpload', 'blockQuote', '|', 'undo', 'redo', '|', 'mediaEmbed', '|', 'insertTable', '|', 'delete'],
      isReadOnly: true
    };

    breadcrumbItems: breadcrumbItem[] = [
      {
        label: "Home",
        active: false,
        url: "/home",
      },
      {
        label: "Support Tickets",
        active: true,
        url: "",
      },
    ];

    active = 1;

    isEmpty: boolean = false;
    isSearch: boolean = false;
    @ViewChild(DataTableDirective)
    datatableElement: DataTableDirective;
    dtOptions: DataTables.Settings = { paging: true };
    dtTrigger: Subject<any> = new Subject();

    merchantId = this.cookieService.get("merchantId");
    currency: any = this.cookieService.get("currency");
    searchName: any;

    status: any;
    totalHours: any;
    page = 1;
    count = 0;
    tableSize = 10;
    reports: any = [];
    startTodayTime: any;
    endOfWeekTime: any;
    timeFormatRegex = "^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$";
    isValidTimeShift: any = true;
    isValidTimeShiftHours: any = true;
    isValidTimeAssignedSection: any = true;
    isValidTimeAssignedTab: any = true;
    isValidTimeStartTime: any = true;
    isValidTimeEndTime: any = true;
    value: string;
    storeId: any = this.cookieService.get("storeId");
    params: any = new HttpParams();
    timeAndHourDuration: any;
    httpOptions = {};
    httpOptions2 = {};
    headerToken = {
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    };
    GLOBALURL: string;
    totalCount: number;
    totalClose: number;
    totalOpen: number;
    canAccess: boolean = true;



    userData = this.authService.getUserFromLocalStorage();
    selectedEmployee: any;
    hourForm: FormGroup;
    requestTimeOffForm: FormGroup;
    addShiftForm: FormGroup;
    hours = [];
    isLoading = false;
    isLessThanEndTime = true;
    issueDescription = "";

    locations$: any = [];

    isLoadingUploadeEmployee = false;

    showUploadEmployeeProgress = false;
    isUploadEmployeeDone = false;

    employeeFiles: File[] = [];
    progress = 0;



    newEventDate: any;
    schedule = [];
    scheduleModalRef: NgbModalRef;
    requestTimeOffModalRef: NgbModalRef;
    addShiftModalRef: NgbModalRef;

    recurring = false;
    nextDay = false;

    startTime = "00:00";
    endTime = "00:00";

    //location service check if load data
    isLoadData = false;
    settings: any;
    formattedTotalHours: string;
    timeError: boolean = false;
    supportPin: any;
    displayPin: any;
    currantEmployee: any;
    startDate: any = this.timezoneService.get()().startOf("day");
  endDate: any = this.timezoneService.get()().endOf("day");
  startDateDisplay: any = this.startDate.unix();
  endDateDisplay: any = this.endDate.unix();
  startDateDisplayFormatted: any = this.timezoneService.get()
    .unix(this.startDateDisplay)
    .format("MMM Do YYYY");
  endDateDisplayFormatted: any = this.timezoneService.get()
    .unix(this.endDateDisplay)
    .format("MMM Do YYYY");
  options: any = {
    locale: { format: "YYYY-MM-DD" },
    startDate: this.timezoneService.get()().startOf("day"),
    endDate: this.timezoneService.get()().endOf("day"),
    alwaysShowCalendars: true,
    ranges: {
      Today: [this.timezoneService.get()(), this.timezoneService.get()()],
      Yesterday: [this.timezoneService.get()().subtract(1, "days"), this.timezoneService.get()().subtract(1, "days")],
      "Last 7 Days": [this.timezoneService.get()().subtract(6, "days"), this.timezoneService.get()()],
      "Last 30 Days": [this.timezoneService.get()().subtract(29, "days"), this.timezoneService.get()()],
      "This Month": [this.timezoneService.get()().startOf("month"), this.timezoneService.get()().endOf("month")],
      "Last Month": [
        this.timezoneService.get()().subtract(1, "month").startOf("month"),
        this.timezoneService.get()().subtract(1, "month").endOf("month"),
      ],
    },
  };

    constructor(
      @Inject(DOCUMENT) private document: any,
      config: NgbModalConfig,
      private translatePipe: TranslatePipe,
      public modalService: NgbModal,
      private fb: FormBuilder,
      private employeeListService: EmployeeListService,
      private jobTypeService: JobTypeService,
      private authService: AuthenticationService,
      private toastr: AlertService,
      private store: Store<AppState>,
      private router: Router,
      public route: ActivatedRoute,
      private cookieService: CookieService,
      private locService: locationBroadcastService,
      private modalConfig: NgbModalConfig,
      public http: HttpClient,
      private ApiService: ApiService,
      private BreadcrumbService: BreadcrumbService,
      private timezoneService: TimezoneService,
      private locationService: LocationsService,
      private renderer: Renderer2,
      public permissionService: PermissionService,
      private el: ElementRef,
      private cdr: ChangeDetectorRef,
      private AppAliasService: AppAliasService,
      public offcanvasService: NgbOffcanvas,
      private toastrservice: AlertService,
      private supportPinService: SupportPinService,
    ) {

      this.GLOBALURL = this.ApiService.getBaseURL();
      this.employeeListService.GLOBALURL = this.ApiService.getBaseURL();

      if (this.cookieService.get("superAdminPage") !== "3") {
        this.toastr.error('Logged-in account should be a Super Admin.')
        this.router.navigate(['/home']);
        return;
      }

      // this.requestTimeOffForm = fb.group({
      //   employeeId: ["", Validators.required],
      //   employeeScheduleNotes: ["", Validators.required],
      //   employeeScheduleType: [2],
      //   endDate: ["", Validators.required],
      //   jobtypeId: ["", Validators.required],
      //   startDate: ["", Validators.required],
      //   status: [1, Validators.required],

      // });

      // this.addShiftForm = fb.group({
      //   nextDay: [false],
      //   recurring: [false],
      //   allowOvertime: [false],
      //   days: [],
      //   // days: this.fb.array([
      //   //   {
      //   //     day: "Monday",
      //   //     startTime: "",
      //   //     endTime: "",
      //   //     recurring: false,
      //   //     nextDay: false,
      //   //   },
      //   //   {
      //   //     day: "Tuesday",
      //   //     startTime: "",
      //   //     endTime: "",
      //   //     recurring: false,
      //   //     nextDay: false,
      //   //   },
      //   //   {
      //   //     day: "Wednesday",
      //   //     startTime: "",
      //   //     endTime: "",
      //   //     recurring: false,
      //   //     nextDay: false,
      //   //   },
      //   //   {
      //   //     day: "Thursday",
      //   //     startTime: "",
      //   //     endTime: "",
      //   //     recurring: false,
      //   //     nextDay: false,
      //   //   },
      //   //   {
      //   //     day: "Friday",
      //   //     startTime: "",
      //   //     endTime: "",
      //   //     recurring: false,
      //   //     nextDay: false,
      //   //   },
      //   //   {
      //   //     day: "Saturday",
      //   //     startTime: "",
      //   //     endTime: "",
      //   //     recurring: false,
      //   //     nextDay: false,
      //   //   },
      //   //   {
      //   //     day: "Sunday",
      //   //     startTime: "",
      //   //     endTime: "",
      //   //     recurring: false,
      //   //     nextDay: false,
      //   //   },
      //   // ]),
      //   employeeId: ["", Validators.required],
      //   employeeScheduleName: ["", Validators.required],
      //   employeeScheduleNotes: [""],
      //   employeeScheduleType: [7],
      //   endDate: ["", Validators.required],
      //   jobtypeId: ["", Validators.required],
      //   startDate: ["", Validators.required],
      //   status: [1],
      // });

      this.params = new HttpParams();

      this.dtOptions = {
        pageLength: 10,
        language: {
          emptyTable: "No Tickets Available in Table",
          searchPlaceholder: "Search Tickets",
          search: "",
        },
        // scrollY: 'calc(100vh - 510px)',
        // scrollCollapse: true,
        scrollX: true,
        ordering: false,
        // dom: '<"top"f>t<"bottom"lip>',
        dom: '<"top" f><"table-params" t><"bottom" lip>',
        paging: true,
        //columnDefs: [{ targets: 3, orderable: false }],
        pagingType: "simple_numbers",
        serverSide: true,
        processing: false,

        ajax: (dataTablesParameters: any, callback) => {
          //objectToHttpParams added outside ngonit
          const params: any = this.objectToHttpParams(dataTablesParameters);
          this.storeId = this.cookieService.get("storeId");
          this.params = new HttpParams();

          const search = JSON.parse(
            params.updates.find((obj) => {
              return obj.param === "search";
            }).value
          ).value;

          // find out offset
          const offset = params.updates.find((obj) => {
            return obj.param === "start";
          }).value;

          // find out limit
          const limit = params.updates.find((obj) => {
            return obj.param === "length";
          }).value;

          this.value = this.cookieService.get("token");

          // this.params = this.params.set("storeId", this.storeId);
          // this.params = this.params.set("startDate", this.startDateDisplay);
          // this.params = this.params.set("endDate", this.endDateDisplay);
          this.params = this.params.set("status", 1);

          // set params as per search key value
          this.params = this.params.set("limit", limit);
          this.params = this.params.set("offset", offset);
          if (search !== "") {
            this.params = this.params.set("search", search);
            this.isSearch = true;
          }

          this.httpOptions = { headers: new HttpHeaders(this.headerToken) };

          this.dataSubscription = this.http
            .get(this.GLOBALURL + "/merchants/issues", {
              headers: new HttpHeaders(this.headerToken),
              params: this.params,
            })
            .subscribe(
              (response: any) => {
                this.totalClose = response.closeIssue,
                this.totalCount = response.total,
                this.totalOpen = response.openIssue,
                this.store.dispatch(setLoadingSpinner({ status: false }));
                // response.total = response?.response?.length || 0
                if (response.total <= 0 && this.isSearch === false)
                  this.isEmpty = true;
                else this.isEmpty = false;
                callback({
                  recordsTotal: response.total,
                  recordsFiltered: response.total,
                  data: [],
                  // add one more key to store the response data
                  response: response.response,
                });
                this.employees = [];
                response?.response?.forEach((element, index) => {
                  let character = "";
                  character = element?.employeeFirstName?.trim();
                  var a = character?.split(" ");
                  // character = a[0]?.charAt(0)?.toUpperCase();
                  // element.char = character;
                  element.index = index;
                  this.employees.push(element);
                  console.log("this.employees_EMPLOYEES", this.employees);
                });
                window.dispatchEvent(new Event("resize"));
                this.renderer.removeClass(document.body, "sidebar-enable");
                this.renderer.addClass(document.body, "vertical-collpsed");
                this.employees.filter((data) => {
                  return data.status == 1;
                });
                return;
              },
              (error) => {
                this.store.dispatch(setLoadingSpinner({ status: false }));
                this.isEmpty = true;
              }
            );

          return this.dataSubscription;
        },
        // drawCallback: () => {
        //   if ($('.dataTables_empty').length) {
        //     $('.dataTables_empty').hide();
        //   }

        //   if ($('.dataTables_info').length) {
        //     let text = $('.dataTables_info')[0]?.outerText;

        //     this.translatePipe.transform(text)
        //       .subscribe(res => {
        //         $('.dataTables_info').text(res);
        //       });
        //   }

        //   let $dataTablesLength = $('.dataTables_length label');
        //   if ($dataTablesLength) {
        //     let $dataTablesLength = $('.dataTables_length label');

        //     let textNode = $dataTablesLength.contents().filter(function() {
        //       return this.nodeType === Node.TEXT_NODE;
        //     });

        //     if (textNode.length > 0 && textNode.length === 2) {
        //       forkJoin([
        //         this.translatePipe.transform('Show'),
        //         this.translatePipe.transform('entries'),
        //         this.translatePipe.transform('Previous'),
        //         this.translatePipe.transform('Next'),
        //         this.translatePipe.transform(this.dtOptions.language.searchPlaceholder)
        //       ]).subscribe(([showTranslation, entriesTranslation, prevText, nextText, search]) => {
        //           textNode[0].nodeValue = showTranslation;
        //           textNode[1].nodeValue = entriesTranslation;
        //           $('.paginate_button.previous')[0].innerText = prevText;
        //           $('.paginate_button.next')[0].innerText = nextText;
        //           $('.dataTables_filter label input').attr('placeholder', search);
        //         },
        //         (error) => {});
        //     }
        //   }
        // }
        drawCallback: () => {
          const dataTable = $('#employees-table').DataTable();
          $('.dataTables_empty').hide();  // Hide "No matching records found" if necessary
        
          // Update pagination info
          const pageInfo = dataTable.page.info();
          const totalRecords = pageInfo.recordsTotal;
          const start = pageInfo.start + 1;
          let end = pageInfo.start + pageInfo.length;
          if (totalRecords < pageInfo.length) {
              end = pageInfo.length; // If fewer records than per page limit, extend end to full page size
          } else {
              end = Math.min(end, totalRecords); // Adjust end if it exceeds the total records otherwise
          }
        
          // Adjust the displaying end to the maximum if the total records number is less than page size
          const displayEnd = pageInfo.recordsDisplay < pageInfo.length ? pageInfo.length : Math.min(pageInfo.length, pageInfo.recordsDisplay);
        
          const customPaginationText = `Showing ${start} to ${displayEnd} of ${totalRecords} entries`;
        
          // Translate and update the pagination info text
          this.translatePipe.transform(customPaginationText).subscribe(translatedText => {
            $('.dataTables_info').text(translatedText);
          });
        
          // Update DataTable Length Label and Buttons
          let $dataTablesLengthLabel = $('.dataTables_length label');
          let textNode = $dataTablesLengthLabel.contents().filter(function() {
              return this.nodeType === Node.TEXT_NODE;
          });
          if (textNode.length > 0 && textNode.length === 2) {
            forkJoin([
              this.translatePipe.transform('Show'),
              this.translatePipe.transform('entries'),
              this.translatePipe.transform('Previous'),
              this.translatePipe.transform('Next')
            ]).subscribe(([showTranslation, entriesTranslation, prevText, nextText]) => {
              textNode[0].nodeValue = showTranslation;
              textNode[1].nodeValue = entriesTranslation;
        
              $('.paginate_button.previous').text(prevText);
              $('.paginate_button.next').text(nextText);
            });
          }
        
          // Update search placeholder text
          let $searchInput = $('.dataTables_filter label input');
          if ($searchInput.length > 0) {
            this.translatePipe.transform(this.dtOptions.language.searchPlaceholder).subscribe(placeholder => {
              $searchInput.attr('placeholder', placeholder);
            });
          }
        }
      };


      this.translatePipe.transform(this.dtOptions.language.searchPlaceholder)
      .subscribe(res => {
        this.dtOptions.language.searchPlaceholder = res;
      });


      this.dropdownSettings = {
        singleSelection: false,
        idField: "item_id",
        textField: "item_text",
        // day: "day",
        // startTime: "startTime",
        // endTime: "endTime",
        // recurring: "recurring",
        // nextDay: "nextDay",
        selectAllText: "Select All",
        unSelectAllText: "UnSelect All",
        itemsShowLimit: 2,
        allowSearchFilter: "ShowFilter",
      };
    }

    getCustomDate(inputDate, customHour, customMinutes) {
      // Create a new Date object based on the input date
      var date = new Date(inputDate);

      // Set the custom hour and minutes to the date
      date.setHours(customHour);
      date.setMinutes(customMinutes);

      // Get Unix timestamp (in seconds) by dividing milliseconds by 1000
      var timestampInSeconds = Math.floor(date.getTime() / 1000);

      return timestampInSeconds;
    }

    unixToDate(date) {
      return this.timezoneService
        .get()(date * 1000)
        .format("MM-DD-YYYY");
    }

    //to be removed
    dropdownList = [];
    selectedItems = [];
    dropdownSettings = {};
    dropdownSettings2 = {}
    sampletr: boolean = false;
    timezone;
    selectedDate(value: any) {
      // this.showItemCountPP = 0;
      // this.p = 1;
      this.startDate = value.start;
      this.endDate = value.end;
      // console.log("STARTDATEEEEEEEEE", this.startDate)
      // console.log("ENDDDATEEEEEEEEE", this.endDate)
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      // console.log("STARTDISPLAYYYYYYYY", this.startDateDisplay)
      // console.log("ENDDDISPLAYYYYYYYY", this.endDateDisplay)
      this.startDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.startDateDisplay)
        .format("MMM Do YYYY");
      this.endDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.endDateDisplay)
        .format("MMM Do YYYY");
        //  this.refreshDataTable3();
      this.getSupportTicketsForSelectedDates();
    }
    refreshDataTable3() {
      this.store.dispatch(setLoadingSpinner({ status: true }));
      console.log("objectrefreshDataTable :>> ", this.datatableElement)
      if (this.datatableElement) {
        this.datatableElement?.dtInstance.then((dtInstance: DataTables.Api) => {
          // Reload the table data from the Ajax data source
          dtInstance.ajax.reload((json) => {
            console.log("dtinstance_FROM_AJAX", dtInstance.data(), dtInstance.page.info(), json);
            // If the response data is empty, go to the first page
            // this.activityLog = json.response;
            if (json.response.length === 0 && dtInstance.page.info().page > 0) {
              console.log("Data table refreshed and going to first page")
              dtInstance.page('first').draw('page');
            }
          }, false); // Pass false to keep the current paging position
          console.log("Data table refreshed");
        });
      }
    }
    getSupportTicketsForSelectedDates(offset = 0, limit = 10) {
      this.store.dispatch(setLoadingSpinner({ status: true }));
      
      const params = new HttpParams()
        // .set('storeId', this.storeId)
        .set('offset', offset.toString())
        // .set('limit', limit.toString())
        // .set('merchantId', this.merchantId)
        .set('startDate', this.startDateDisplay)
        .set('endDate', this.endDateDisplay)
        .set('status', '1');
    
      this.http.get<{ success: number, response: any, total: number, closeIssue: number , openIssue :number}>(`${this.GLOBALURL}/merchants/issues`, { params })
        .subscribe({
          next: data => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            if (data.success === 1) {
              console.log("DATAAAAAAAAAAAAA", data)
              this.totalCount = data.total;
              this.employees = data.response;
              this.totalClose = data.closeIssue;
              this.totalOpen = data.openIssue;
              this.cdr.detectChanges();
            } else {
              this.toastr.error('Failed to load data');
            }
          },
          error: error => {
            this.toastr.error('An error occurred');
            this.store.dispatch(setLoadingSpinner({ status: false }));
          }
        });
    }
    createTranslateArr(arr: any) {
      let newArr = [];
      arr.forEach((item) => {
        if (item && typeof item.textContent === 'string') {
          newArr.push(this.translatePipe.transform(item.textContent));
        }
      });
      return newArr;
    }
    translateArrayOfTexts($arrToTranslate: string[], arrOfElements: any) {
      if ($arrToTranslate.length === 0) return;
  
      forkJoin($arrToTranslate)
        .subscribe(texts => {
          texts.forEach((text, i) => {
            arrOfElements[i].textContent = text;
          });
        },
        (error) => {
          console.error("Error in translating:", error);
        })
    }
    setDateTexts() {
      setTimeout(() => {
        let ranges = document.querySelectorAll(".ranges li");
        let $ranges = this.createTranslateArr(ranges);
  
        let months = document.querySelectorAll(".table-condensed .month");
        let $months = this.createTranslateArr(months);
  
        let buttons = document.querySelectorAll(".drp-buttons .btn");
        let $buttons = this.createTranslateArr(buttons);
    
        // this.translateArrayOfTexts($first, first);
        this.translateArrayOfTexts($buttons, buttons);
        this.translateArrayOfTexts($ranges, ranges);
        this.translateArrayOfTexts($months, months)
  
      }, 1);
  
    }
  // getStoreSupportTicketsForSelectedDates() {
  //   throw new Error("Method not implemented.");
  // }


    // ################################# To Be Removed ############################
    fakeEmployeeOrderHistory = [
      {
          "serverId": "65ae604a9bde7a5626e42787",
          "orderType": 1,
          "paymentId": "",
          "subTotalAmount": 5,
          "actualPaidAmount": 5.48,
          "totalAmount": 5.48,
          "taxAmount": 0.48,
          "serviceChargeAmount": 0,
          "revenueCenterId": "65cb15525225343213c13b94",
          "status": 1,
          "createdAt": 1721387641,
          "orderNumber": 1,
          "orderId": "771763d28ef3772167f7f051",
          "lastSession": 1721633924,
      },
      {
          "serverId": "65ae604a9bde7a5626e42787",
          "orderType": 1,
          "paymentId": "",
          "subTotalAmount": 10000,
          "actualPaidAmount": 5512.5,
          "totalAmount": 5512.5,
          "taxAmount": 512.5,
          "serviceChargeAmount": 0,
          "revenueCenterId": "65dec36b75a696fb3edd1a3d",
          "status": 1,
          "createdAt": 1721040947,
          "orderNumber": 2,
          "orderId": "104053089a4e2547b17e34aa",
          "lastSession": 1721633924,
      },
      {
          "serverId": "65ae604a9bde7a5626e42787",
          "orderType": 1,
          "paymentId": "",
          "subTotalAmount": 10000,
          "actualPaidAmount": 11025,
          "totalAmount": 11025,
          "taxAmount": 1025,
          "serviceChargeAmount": 0,
          "revenueCenterId": "65dec36b75a696fb3edd1a3d",
          "status": 1,
          "createdAt": 1721040873,
          "orderNumber": 1,
          "lastSession": 1721633924,
          "orderId": "c101bd1a6621756187a10004"
      },
      {
          "serverId": "65ae604a9bde7a5626e42787",
          "orderType": 8,
          "paymentId": "",
          "subTotalAmount": 7.3,
          "actualPaidAmount": 8.04,
          "totalAmount": 8.04,
          "taxAmount": 0.74,
          "serviceChargeAmount": 0,
          "revenueCenterId": "65dec36b75a696fb3edd1a3d",
          "createdAt": 1720524972,
          "status": 1,
          "orderNumber": 4,
          "lastSession": 1721633924,
          "orderId": "668d20ac16f9aed7ae6edc27"
      },
      {
          "serverId": "65ae604a9bde7a5626e42787",
          "orderType": 8,
          "paymentId": "",
          "subTotalAmount": 3.65,
          "actualPaidAmount": 4.02,
          "totalAmount": 4.02,
          "taxAmount": 0.37,
          "serviceChargeAmount": 0,
          "revenueCenterId": "65dec36b75a696fb3edd1a3d",
          "createdAt": 1720519408,
          "status": 1,
          "orderNumber": 3,
          "lastSession": 1721633924,
          "orderId": "668d0aef16f9aed7ae6ed879"
      },
      {
          "serverId": "65ae604a9bde7a5626e42787",
          "orderType": 8,
          "paymentId": "",
          "subTotalAmount": 7.3,
          "actualPaidAmount": 8.04,
          "totalAmount": 8.04,
          "taxAmount": 0.74,
          "serviceChargeAmount": 0,
          "revenueCenterId": "65dec36b75a696fb3edd1a3d",
          "createdAt": 1720519204,
          "status": 1,
          "orderNumber": 1,
          "lastSession": 1721633924,
          "orderId": "668d0a2416f9aed7ae6ed4e3"
      },
      {
          "serverId": "65ae604a9bde7a5626e42787",
          "orderType": 1,
          "paymentId": "",
          "subTotalAmount": 30,
          "actualPaidAmount": 0,
          "totalAmount": 33.74,
          "taxAmount": 3.14,
          "serviceChargeAmount": 0.6,
          "revenueCenterId": "65dec36b75a696fb3edd1a3d",
          "status": 1,
          "createdAt": 1720443109,
          "orderNumber": 11,
          "lastSession": 1721633924,
          "orderId": "c5d404f4d8319862122d1747"
      },
      {
          "serverId": "65ae604a9bde7a5626e42787",
          "orderType": 8,
          "paymentId": "",
          "subTotalAmount": 44,
          "actualPaidAmount": 48.51,
          "totalAmount": 48.51,
          "taxAmount": 4.51,
          "serviceChargeAmount": 0,
          "revenueCenterId": "65dec36b75a696fb3edd1a3d",
          "createdAt": 1720438661,
          "status": 1,
          "orderNumber": 7,
          "lastSession": 1721633924,
          "orderId": "668bcf8516f9aed7ae6eae03"
      },
      {
          "serverId": "65ae604a9bde7a5626e42787",
          "orderType": 8,
          "paymentId": "",
          "subTotalAmount": 124,
          "actualPaidAmount": 130.57,
          "totalAmount": 130.57,
          "taxAmount": 6.57,
          "serviceChargeAmount": 0,
          "revenueCenterId": "65dec36b75a696fb3edd1a3d",
          "createdAt": 1720438530,
          "status": 1,
          "orderNumber": 6,
          "lastSession": 1721633924,
          "orderId": "668bcf0116f9aed7ae6ead3b"
      },
      {
          "serverId": "65ae604a9bde7a5626e42787",
          "orderType": 1,
          "paymentId": "",
          "subTotalAmount": 30,
          "actualPaidAmount": 0,
          "totalAmount": 33.74,
          "taxAmount": 3.14,
          "serviceChargeAmount": 0.6,
          "revenueCenterId": "65dec36b75a696fb3edd1a3d",
          "status": 1,
          "createdAt": 1720185325,
          "orderNumber": 12,
          "lastSession": 1721633924,
          "orderId": "0088072f73ca217d5f0ad507"
      }
  ];
    // ############################ To Be Removed ############################
    restaurantSettings = [
      {
        settingName: "InactivityTimer",
        settingValue: true,
        displayName: "Inactivity Timer",
      },
      { settingName: "Language", settingValue: "", displayName: "Language" },
      { settingName: "Currency", settingValue: "", displayName: "Currency" },
      { settingName: "Timezone", settingValue: "", displayName: "Timezone" },
      {
        settingName: "DepositTime",
        settingValue: "17:00",
        displayName: "Deposit Time",
      },
      {
        settingName: "ReportsRequiredManagerPIN",
        settingValue: true,
        displayName: "Reports",
      },
      {
        settingName: "EndOfDayRequiredManagerPIN",
        settingValue: true,
        displayName: "End of Day",
      },
      {
        settingName: "StartOfDayTime",
        settingValue: "12:00",
        displayName: "Day & Week Start/End Time",
      },
      {
        settingName: "StartOfWeekDay",
        settingValue: "Monday",
        displayName: "Day & Week Start/End",
      },
      {
        settingName: "StartOfHourByDay",
        settingValue: "00:00",
        displayName: "Start Time",
      },
      {
        settingName: "EndOfHourByDay",
        settingValue: "12:00",
        displayName: "End Time",
      },
      {
        settingName: "ClosingDay",
        settingValue: "Same Day",
        displayName: "End Day",
      },
    ];
    async ngOnInit() {
      if (!this.permissionService.canAccessSuper('Support Tickets', 1)) {
        this.toastr.error("You are not authorized to perform this operation.");
        this.router.navigate(['/overview']);
        return;
      }
      this.store.dispatch(setLoadingSpinner({ status: true }));
      this.editorConfig = {
        ...this.editorConfig,
        isReadOnly: true
      };

      // Configure CKEditor
    // this.ckconfig = {
    //   placeholder: "Please Describe the Issue...",
    //   // plugins: [
    //   //   Base64UploadAdapter,
    //   // ],
    //   toolbar: {
    //   items: [
    //     'heading', '|',
    //     'bold', '|',
    //     'link', '|',
    //     // 'outdent', 'indent', '|',
    //     'bulletedList', 'numberedList', '|',
    //     'imageUpload', 'blockQuote', '|',
    //     'undo', 'redo', '|',
    //     'mediaEmbed', '|',
    //     'insertTable',
    //   ]
    //  },
    //  extraPlugins: [ this.customAdapterPlugin ]
    // //  extraPlugins: [this.customUploadAdapterPlugin.bind(this)],
    // // simpleUpload: {
    // //   uploadUrl: this.getUploadUrl(),
    // //   headers: {
    // //     enctype: "multipart/form-data",
    // //     Authorization: this.cookieService.get("token"),
    // //   }
    // // }
    // };

      this.BreadcrumbService.setValue(this.breadcrumbItems);

      if (this.cookieService.get("superAdminPage") !== "3") {
        this.toastr.error('Logged-in account should be a Super Admin.')
        this.router.navigate(['/home']);
        return;
      }

      if (!Boolean(this.currency)) {
        this.currency = "$";
      }

      this.AppAliasService.getStoreValue().subscribe((res) => {
        if (res === '*') {
          this.toastr.error('Please select a store');
          return;
        }
      }
      );
      // this.store.dispatch(setLoadingSpinner({ status: true }));
      const  geticon=this.el.nativeElement.querySelector('.fc-icon fc-icon-chevron-left');

      if (geticon) {
        this.renderer.removeClass(geticon, 'fc-icon fc-icon-chevron-left');
        this.renderer.addClass(geticon, 'fa-solid fa-less-than');
      }

      this.modalConfig.backdrop = "static";
      this.modalConfig.keyboard = false;

      //to be removed

      // this.addShiftForm.controls.startDate.setValue(
      //   this.timezoneService.get()(this.rangestartDate).unix().toString()
      // );
      // this.addShiftForm.controls.endDate.setValue(
      //   this.timezoneService.get()(this.rangeendDate).unix().toString()
      // );
      // this.rangestartDateDisplay = this.rangestartDate.format("MM/DD/YYYY");
      // this.rangeendDateDisplay = this.rangeendDate.format("MM/DD/YYYY");
      // this.addShiftForm.controls.startDate.setValue(this.rangestartDateDisplay);
      // this.addShiftForm.controls.endDate.setValue(this.rangeendDateDisplay);
      // end to be removed

    }


    startTimeFormatted: any = "";
    endTimeFormatted: any = "";
    dateTimeArray: any[] = [];
    ClosingDay = "Same Day";




    objectToHttpParams(obj: any) {
      return Object.entries(obj || {}).reduce((params, [key, value]) => {
        return params.set(
          key,
          _.isObjectLike(value) ? JSON.stringify(value) : String(value)
        );
      }, new HttpParams());
    }

    reload() {
      // save current route first
      const currentRoute = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = "reload";
      this.router.navigate([currentRoute]);
    }

    // date: any
    // day: any
    // month: any
    // year: any
    today: any;

    startDateWithTime: any;
    endDateWithTime: any;

    timeChange(event: any, field: any) {
      var re = new RegExp(this.timeFormatRegex);
      var valid = re.test(event.target.value);
      if (field === "start time") this.startTime = event.target.value;
      if (field === "end time") this.endTime = event.target.value;
      switch (field) {
        case "shift":
          if (valid) {
            this.isValidTimeShift = true;
            break;
          }
          this.isValidTimeShift = false;
          break;
        case "shift hours":
          if (valid) {
            this.isValidTimeShiftHours = true;
            break;
          }
          this.isValidTimeShiftHours = false;
          break;
        case "assigned section":
          if (valid) {
            this.isValidTimeAssignedSection = true;
            break;
          }
          this.isValidTimeAssignedSection = false;
          break;
        case "assigned tab":
          if (valid) {
            this.isValidTimeAssignedTab = true;
            break;
          }
          this.isValidTimeAssignedTab = false;
          break;
        case "start time":
          if (valid) {
            this.isValidTimeStartTime = true;
            break;
          }
          this.isValidTimeStartTime = false;
          break;
        case "end time":
          if (valid) {
            this.isValidTimeEndTime = true;
            break;
          }
          this.isValidTimeEndTime = false;
          break;
      }
    }


    // refreshDataTable() {
    //   this.datatableElement?.dtInstance.then((dtInstance: DataTables.Api) => {
    //     dtInstance.draw();
    //   });
    // }

    refreshDataTable() {
      if (this.datatableElement) {
        this.datatableElement?.dtInstance.then((dtInstance: DataTables.Api) => {
          // Reload the table data from the Ajax data source
          dtInstance.ajax.reload((json) => {
            console.log("dtinstance_FROM_AJAX", dtInstance.data(), dtInstance.page.info(), json);
            // If the response data is empty, go to the first page
            if (json.response.length === 0 && dtInstance.page.info().page > 0) {
              console.log("Data table refreshed and going to first page")
              dtInstance.page('first').draw('page');
            }
          }, false); // Pass false to keep the current paging position
          console.log("Data table refreshed");
        });
      }
    }

    // customAdapterPlugin(editor) {
    //   editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    //     console.log("customAdapterPlugin_LOADER", loader);
    //     console.log("customAdapterPlugin_EDITOR", editor);
    //     return new Adapter(loader, editor.config);
    //   };
    // }

    onChange(event: ChangeEvent): void {
      console.log("onCange", event.editor?.getData());
      this.componentEvents.push('Editor model changed.');
    }

    onFocus(event: FocusEvent): void {
      this.componentEvents.push('Focused the editing view.');
    }

    onBlur(event: BlurEvent): void {
      this.componentEvents.push('Blurred the editing view.');
    }
    onReady(editor){
      editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
        console.log("OnReady_LOADER", loader);
        console.log("OnReady_EDITOR", editor);
      return new Adapter(loader, editor.config);;
  };

    }

     createIssue(status?: any) {
      try {
        // await this.generateSupportPin();
        console.log("this.editorContent", this.editorContent);
        let issueStatus: number;

        if (status == "close"){
           issueStatus = 1;
        }
        else{
           issueStatus = this.currantEmployee.issueStatus;
        }
        const payload: any = {
          merchantIssueId: this.currantEmployee.merchantIssueId,
          describeIssue: this.editorContent,
          updatedEmployeeId: this.currantEmployee.updatedEmployeeId,
          merchantId: this.currantEmployee.merchantId,
          storeId: this.currantEmployee.storeId,
          employeeId: this.currantEmployee.employeeId,
          issueStatus: issueStatus,
        };
        this.http.put(this.GLOBALURL + "/merchants/issues", payload).subscribe(
          (response: any) => {
            if (!response.error) {
              this.toastr.success("Support tickets updated successfully.");
              this.offcanvasService.dismiss("cross click");
              this.refreshDataTable();
              // this.router.navigate(["/master/device"]);
            } else {
              this.toastr.clear();
              this.toastr.error(response.message);
            }
          },
          (error) => {
            const message = this.ApiService.errorMessage(error);
            this.toastr.clear();
            this.toastr.error(message);
          }
        );
      } catch (error) {
        console.error("Error generating support pin:", error);
      }
    }
    UpdateSupportPin() {
      const payload = {
        employeeId: this.currantEmployee.employeeId,
        supportPin: this.supportPin,
      };
      this.supportPinService.updateSupportPin(payload).subscribe(
        (res: any) => {
          if (res.success === 0) {
            this.toastrservice.error(res.message);
          } else {
            this.toastrservice.success(res.message);
          }
        },
        (error) => {
          console.log(error);
          this.toastrservice.error(error || error?.message || "Error updating support pin");
        }
      );
    }

    employeeDetails: any = {};
    employeeServerId: any;
    employeeOrderHistory: any = [];
    loaderState = false;

    /**
   * Open modal
   * @param content modal content
   */
  openModal(content: any, employee: any) {
    console.log("OPEN MODAL", employee);
    this.editorContent = employee.describeIssue;
    // console.log("ClassicEditor.ui.componentFactory.names()", ClassicEditor.ui.componentFactory.names());
    // ## DEEP COPY WITH JSON TO UPDATE THE VALUES IN MODAL
    let copyObj = JSON.parse(JSON.stringify(employee));
    this.employeeDetails = copyObj;
    this.openEnd(content);
    this.loaderState = false;
    this.currantEmployee = employee;
    // setTimeout(() => {
    //   if(this.fakeEmployeeOrderHistory.length > 0) {
    //     this.employeeOrderHistory = this.fakeEmployeeOrderHistory;
    //     this.loaderState = false;
    //   }
    // } , 2000);


   
  }
  fetchEmployeeOrderHistory() {
    // API Call to get the Order History
    this.loaderState = true;
    this.http.get(this.GLOBALURL + "/order/employeesummary", {
     headers: new HttpHeaders(this.headerToken),
     // params: new HttpParams().set("serverId", this.currantEmployee.employeeId),
     params: new HttpParams()
             .set("storeId", this.currantEmployee.storeId)
             .set("count", "5"),

   }).subscribe((response: any) => {
     if (response.success) {
       console.log("EMPLOYEE_ORDER_History", response);
       this.employeeOrderHistory = response.response;
       this.loaderState = false;
      } else {
        this.modalService.dismissAll();
        this.offcanvasService.dismiss("cross click");
        this.loaderState = false;
        this.toastr.error(response.message);
      }
    }, (error) => {
      this.modalService.dismissAll();
        this.offcanvasService.dismiss("cross click");
        this.loaderState = false;
      const message = this.ApiService.errorMessage(error);
      this.toastr.error(message);
    });
  }
  openEnd(employeedetail: TemplateRef<any>) {
    this.offcanvasService.open(employeedetail, { position: "end" });
    this.loaderState = true;
  }

  closeModal(content: any) {
    console.log("CLOSE MODAL");
    this.modalService.dismissAll(content);
    this.offcanvasService.dismiss("cross click");
  }

  closeEnd() {
    this.offcanvasService.dismiss("cross click");
  }

  _convertDateKeys = {};
  _convertDate = (id: string, date: any) => {
    if (!this._convertDateKeys[id]) {
      if (date) {
        this._convertDateKeys[id] = this.timezoneService
          .get()(date * 1000)
          .format("MMM DD, YYYY");
      } else {
        return "";
      }
    }
    return this._convertDateKeys[id];
  };

  _convertTimeKeys = {};
  _convertTime = (id: string, date: any) => {
    if (!this._convertTimeKeys[id]) {
      if (date) {
        this._convertTimeKeys[id] = this.timezoneService
          .get()
          .unix(date)
          .format("h:mm A");
      } else {
        return "";
      }
    }
    return this._convertTimeKeys[id];
  };

  __convertTime = (id: string, date: any) => {
    if (!this._convertTimeKeys[id]) {
      if (date) {
        this._convertTimeKeys[id] = this.timezoneService
          .get()
          .unix(date)
          .format("h:mm A");
      } else {
        return "";
      }
    }
    return this._convertTimeKeys[id];
  };

  orderTypeText(orderType) {
    let text = "No Data";
    if (orderType == 1) {
      text = "Restaurant";
    } else if (orderType == 2) {
      text = "Bar";
    } else if (orderType == 3) {
      text = "Take Out";
    } else if (orderType == 4) {
      text = "App";
    } else if (orderType == 5) {
      text = "Delivery";
    } else if (orderType == 6) {
      text = "Ahead";
    } else if (orderType == 7) {
      text = "Banquet";
    } else if (orderType == 8) {
      text = "Online Ordering";
    } else if (orderType == 10) {
      text = "Drive Thru";
    }
    return text;
  }

    /**
     * Event click modal show
     */
    handleEventClick(clickInfo: EventClickArg) {
      // this.editEvent = clickInfo.event;
      // this.formEditData = this.formBuilder.group({
      //   editTitle: clickInfo.event.title,
      //   editCategory: clickInfo.event.classNames[0],
      // });
      // this.modalService.open(this.editmodalShow);
      console.log("CLICK INFO----", clickInfo.event.title);

    }



    /**
     * Events bind in calander
     * @param events events
     */
    handleEvents(events: EventApi[]) {
      // this.currentEvents = events;
    }

    // to be removed
    open(content) {
      this.modalService.open(content);
    }
    onItemSelect(item: any) {
      console.log(item);
    }
    onSelectAll(items: any) {
      console.log(items);
    }
    //end to be removed

    totalEmployees: any = 0;
    employees = [];
    scheduleEmployees = [];
    employeesCopy: any = [];
    orderByName: boolean = false;
    httpOptions3: any = {};

    totalReports: any = 0;
    httpOptionsReports = {};

    totalJobTypes = 0;
    jobTypes: any = [];
    IsErrorFetchedJobtype = false;


    //Function that order the data registers by name A-Z
    sortByName(arr: any, attr: any, order: any) {
      if (order) {
        order = false;
        this.orderByName = true;
      } else {
        order = true;
        this.orderByName = false;
      }
      return arr.sort((first, second) => {
        if (first[attr].toUpperCase() > second[attr].toUpperCase()) {
          if (order) {
            return 1;
          } else {
            return -1;
          }
        } else if (first[attr].toUpperCase() < second[attr].toUpperCase()) {
          if (order) {
            return -1;
          } else {
            return 1;
          }
        }
      });
    }

    itemsPP: any = 10;
    p: any = 1;
    showItemCountPP: any = 0;

    //update page
    updatePage = (event: any = 1) => {
      this.p = event;
      if (this.p === 1) {
        this.showItemCountPP = 0;
      } else {
        this.showItemCountPP = this.p * this.itemsPP - this.itemsPP;
      }
    };

    showClearBtn: any = false;

    id: any;
    isSelected(employees: any, i: any, employee: any) {
      this.employees.forEach((e) => {
        e.selected = false;
      });

      const foundEmployeeIndex = this.employees?.findIndex((e) => {
        return e.employeeId === employee.employeeId;
      });

      if (foundEmployeeIndex >= 0) {
        this.employees[foundEmployeeIndex].selected = true;
      }
    }

    workingHours: any;
    workingHourId: any;
    allWorkingHours: any = [];

    currentEmployeeJobtypes: any = [];
    selectedJobtype: any;
    clockinPayload: any;
    time: any;


    timeOut: any;




    formatHHMMTime(time, type) {
      let hour = Math.floor(time / 3600);
      let minute = Math.floor((time % 3600) / 60);

      //     // Calculate the time difference in seconds
      //  let timeDifferenceInSeconds = date.endTime - date.startTime;
      //  // Calculate hours and minutes
      //  let hr = Math.floor(timeDifferenceInSeconds / 3600);
      //  let minutes = Math.floor((timeDifferenceInSeconds % 3600) / 60);
      //  // Convert hours and minutes to strings and concatenate
      //   totalHoursString = hr.toString().padStart(2, '0');
      //  let totalMinutesString = minutes.toString().padStart(2, '0');
      //  // Concatenate hours and minutes
      //  let result = totalHoursString + totalMinutesString;
      //  // Convert the result string to a number
      //  let resultNumber = parseInt(result, 10);
      //  console.log('Total Hours:', resultNumber);
      //  let hours = resultNumber

      if (!time) {
        return "0h 0m";
      }

      if (type == 2) {
        return `${hour}hrs ${minute}mins`;
      } else {
        return `${hour}h ${minute}m`;
      }
    }

    convertUnixTime(time) {
      return this.timezoneService
        .get()(new Date(time * 1000))
        .format("h:mm A");
    }

    // edit(employeeId: any) {
    //   this.router.navigate([`/employees/edit-employees/${employeeId}`]);
    // }
    edit(employeeId: any) {
      if (!this.permissionService.canAccess('Employee', 3)) {
        this.toastr.error("You are not authorized to perform this operation.");
        return;
      }
      if (this.storeId === "*") {
        this.toastr.error("Please select a location first.");
        return;
      }

      this.router.navigate([`/employees/edit-employees/${employeeId}`]);
    }

    cancelInvite(content) {
      this.modalService.dismissAll(content);
    }

    inviteEmployeeId: any = "";

    employeeId: any;
    reset2faId: any;
    reset2fa(employeeId: any, reset2faContent: any) {
      console.log("employeeId", employeeId);

      if (!this.permissionService.canAccess('Employee', 3)) {
        this.toastr.error("You are not authorized to perform this operation.");
        return;
      }

      this.reset2faId = employeeId;
      this.modalService.dismissAll();
      this.modalService.open(this.reset2faContent, {
        size: "md archive-modal",
        centered: true,
        windowClass: "animate__animated animate__slideInDown",
      });
      this.RemoveUnwantedClass();
    }

    cancelDelete(reset2faContent) {
      this.modalService.dismissAll(reset2faContent);
    }
    generateSupportPin() {
      // this.supportLoader = true;
      this.supportPinService.getSupportPin().subscribe(
        (res: any) => {
          if (res.success === 0) {
            // this.supportLoader = false;
            this.toastrservice.error(res.message);
          } else {
            this.supportPin = res.data.supportPin;
            let array = this.supportPin.split("");
            this.displayPin = array;
            this.UpdateSupportPin()
            // this.supportLoader = false;
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
    resetEmployee(reset2faId, reset2faContent) {
      // this.submitted=true
      if (reset2faId) {
        let payload={
          employeeId: reset2faId,
        }
         return this.http
        .post(this.GLOBALURL + "/employee/disable2fa", payload, {
          headers: this.headerToken,
        })
        .subscribe(
          (response: any) => {
            if (response.success === 0) {
              this.modalService.dismissAll(reset2faContent);
              this.toastr.error(response.message);
              // this.isLoadingChangeSub.next(false);
            } else {
              this.modalService.dismissAll(reset2faContent);
              this.toastr.success(response.message);
              // this.isLoadingChangeSub.next(false);
              // this.router.navigate(["/merchant-list"]);
            // this.initForm();
            }
          },
          (error) => {
            this.modalService.dismissAll(reset2faContent);
            const message = this.ApiService.errorMessage(error)
            this.toastr.error(message);
            // this.isLoadingChangeSub.next(false);
          }
        );
      } else {
        this.toastr.error("employeeId not present.");
      }
    }

    deleteEmployee(employeeId, content) {
      if (this.storeId === "*" || this.storeId === undefined) {
        this.toastr.error("Please select a location first.");
        return;
      }
      // this.store.dispatch(setLoadingSpinner({ status: true }));

      this.employeeListService.deleteEmployee(employeeId).subscribe(
        (response: any) => {
          if (response.success === 0) {
            this.toastr.error(response.message);
          } else if (!response.error) {
            this.toastr.success(response.message);
            this.modalService.dismissAll(content);
            this.searchName = "";
            this.showClearBtn = false;
            this.refreshDataTable();
          }
          this.store.dispatch(setLoadingSpinner({ status: false }));
        },
        (error) => {
          const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
          this.store.dispatch(setLoadingSpinner({ status: false }));
        }
      );
    }


    isLoadingExport = false;
    exportEmployee() {
      if (this.storeId == "*" || this.storeId == undefined) {
        this.toastr.error("Please select a location first.");
        return;
      }

      this.isLoadingExport = true;
      this.toastr.info("Please wait, exporting employee data...");
      // this.menuService.exportMenu().subscribe(
      this.employeeListService.exportEmployee().subscribe(
        (response: any) => {
          if (response.errors === false) {
            // this.toastr.success(response.message);
            if (response.data && response.data.url) {
              this.toastr.success("File Exported");
              this.isLoadingExport = false;
              const url = response.data.url;
              // const url = response.response.url;
              console.log("url-EXPORT_URL", url);
              let a = document.createElement("a");
              a.href = url;
              a.download = "Export Employee Data";
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            } else {
              this.toastr.error("No data found");
            }
          } else {
            this.toastr.error(response.message);
            this.isLoadingExport = false;
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
          this.isLoadingExport = false;
        }
      );
    }

    // form getter
    get f() {
      return this.hourForm;
    }

    get hoursFormArray() {
      return <FormArray>this.f.get("hours");
    }

    hoursCount: any = 0;
    viewHours(employee) {

      if (!this.permissionService.canAccess('Hours', [1,2,3])) {
        this.toastr.error("You are not authorized to perform this operation.");
        return;
      }

      this.selectedEmployee = employee;
      let selectedJobTypes = []
       this.totalHours = 0;

       if (this.selectedEmployee?.employeeWorkingHours?.workingHours) {
        for (const workingHour of this.selectedEmployee.employeeWorkingHours.workingHours) {
          const startDate = moment.unix(workingHour.startDate);
          const endDate = moment.unix(workingHour.endDate);

          // If end date is less than start date, add a day to end date
          if (endDate.isBefore(startDate)) {
            endDate.add(1, 'day');
          }

          const diffInHours = endDate.diff(startDate, 'hours');
          this.totalHours += diffInHours;
        }

        // Calculate the total hours and minutes
        const totalHours = Math.floor(this.totalHours);
        const totalMinutes = Math.round((this.totalHours - totalHours) * 60);
        // Format the total hours and minutes and check if totalHours is less than 0, then set it to 0, else set it to totalHours
        this.formattedTotalHours = `${totalHours < 0 ? '0' : totalHours}h ${totalMinutes}m`;
      }

        if (
        employee.employeeWorkingHours &&
        Array.isArray(employee.employeeWorkingHours) === false
      ) {
        console.log("1st IF block!")
        const hours: FormArray = this.fb.array([]);
        employee.employeeWorkingHours.workingHours.forEach((h , index) => {
          if (h.type === 0 || h.type === 1 || h.type === 2 || h.type === 3 || h.type === 4
            || h.type === 5 || h.type === 6 || h.type === 7 || h.type === 8) {
            let aa = null;
            let bb = null;
            let a = null;
            let b = null;
            let hoursPerLog: any = ["0h 0m"];

            if (h.startDate > 0) {
              aa = this.timezoneService.get()(
                [
                  this.timezoneService
                    .get()(h.startDate * 1000)
                    .format("HH:mm"),
                ],
                "HH:mm"
              );
              a = this.timezoneService
                .get()(new Date(h.startDate * 1000))
                .format("HH:mm");
            }
            if (h.endDate > 0) {
              bb = this.timezoneService.get()(
                this.timezoneService
                  .get()(h.endDate * 1000)
                  .format("HH:mm"),
                "HH:mm"
              );
              b = this.timezoneService
                .get()(new Date(h.endDate * 1000))
                .format("HH:mm");
            }
            if (bb && aa) {
              if (bb.isBefore(aa)) {
                bb.add(1, 'day');
              }
              hoursPerLog = this.formatHHMMTime(bb.diff(aa) / 1000, 1);
            }


            // const employeeJobTypes = employee.employeeWorkingHours?.workingHours?.map((jobtype) => ({ jobtypeName : jobtype.employeeJobtypeName, jobtypeId : jobtype.employeeJobtypeId }))
            // console.log("Employee job types: ", employeeJobTypes)
            // console.log("Jobtypes: ", this.jobTypes)
            //selectedJobTypes = this.jobTypes.filter((jobtype) => employeeJobTypes.some((employeeJobtype) => employeeJobtype.jobtypeName.toLowerCase() === jobtype.jobtypeName.toLowerCase()))
            //console.log("Selected job types: ", selectedJobTypes)
            //let selectedJobTypeName =selectedJobTypes.map(jobType => jobType.jobtypeId);

            // console.log("jobType.jobtypeId", h.employeeJobtypeId);
            // console.log("jobType.employeeJobtypeName", h.employeeJobtypeName);
            // console.log("jobType.selectedJobTypeName", selectedJobTypeName);
            hours.push(
              this.fb.group({
                startTime: [a, [Validators.required]],
                endTime: [b, [Validators.required]],
                jobType: [h.employeeJobtypeId, [Validators.required]],
                workingHourId: [h.workingHourId],
                hours: [hoursPerLog],
                status: [h.status],
                type: [h.type],
                jobtypeId: [h.employeeJobtypeId],
              })
            );
          }
        });

        // const filteredHours = hours.value.filter((hour) => hour.type === 0 || hour.type === 1);
        // console.log("filteredHours", filteredHours)
        // // Patch the form value
        // this.f.patchValue({
        //   hours: filteredHours,
        // });

        // Sort the hours form array on the basis of only startTime i.e smallest to largest
        console.log("hours", hours);
        this.hoursCount = hours.controls.length;
        // No need to Sort Hours because of NextDay Implementation
        // hours.controls.sort((a, b) => {
        //   if (a.value.startTime > b.value.startTime) {
        //     return 1;
        //   } else if (a.value.startTime < b.value.startTime) {
        //     return -1;
        //   } else {
        //     return 0;
        //   }
        // });

        // hours.controls.sort((a, b) => {
        //   if (a.value.startTime > b.value.startTime) {
        //     return 1;
        //   } else if (a.value.startTime < b.value.startTime) {
        //     return -1;
        //   } else {
        //     if (a.value.endTime > b.value.endTime) {
        //       return 1;
        //     } else if (a.value.endTime < b.value.endTime) {
        //       return -1;
        //     } else {
        //       return 0;
        //     }
        //   }
        // })

        this.hourForm = this.fb.group({
          workedHoursPerDay: [0],
          hours: hours,
          // hours: filteredHours,
        });
        console.log("Hooteen: ", this.f)
        this.setFormListeners();
        // this.modalService.open(this.viewHoursModalContent, {
        //   centered: true,
        //   size: "lg hours-modal",
        // });
        this.RemoveUnwantedClass();
        return;
      }


      console.log("Outside IF block")
      const employeeJobTypes = employee.employeeJobtypes.map((jobtype) => ({ jobtypeName : jobtype.employeeJobtypeName, jobtypeId : jobtype.employeeJobtypeId }))
      console.log("Employee job types: ", employeeJobTypes)
      console.log("Jobtypes: ", this.jobTypes)
      selectedJobTypes = this.jobTypes.filter((jobtype) => employeeJobTypes.some((employeeJobtype) => employeeJobtype.jobtypeName.toLowerCase() === jobtype.jobtypeName.toLowerCase()))
      console.log("Selected job types: ", selectedJobTypes)
      this.hourForm = this.fb.group({
        workedHoursPerDay: [0],
        hours: this.fb.array([
          this.fb.group({
            startTime: [null, [Validators.required]],
            endTime: [null, [Validators.required]],
            jobType: [selectedJobTypes, [Validators.required]],
            workingHourId: [""],
            hours: ["0h 0m"],
            status: [1],
            type: [null],
          }),
        ]),
      });
      console.log("this.hoursFormArray", this.f);
      this.setFormListeners();
      this.RemoveUnwantedClass();
    }

    setFormListeners() {
      // form value changes
      this.f.get("hours").valueChanges.subscribe((value) => {
        // for each hour
        value.forEach((e) => {
          if (e.status === 1) {
            if (e.startTime && e.endTime) {
              const startDate = new Date();
              const endDate = new Date();

              const [startH, startM] = e.startTime.split(":");
              startDate.setHours(startH);
              startDate.setMinutes(startM);

              const [endH, endM] = e.endTime.split(":");
              endDate.setHours(endH);
              endDate.setMinutes(endM);

              // endTime should not be less than startTime
              if (endDate.getTime() < startDate.getTime()) {
                this.isLessThanEndTime = false;
                return;
              } else {
                this.isLessThanEndTime = true;
              }
            }
          }
        });
      });
    }
    validateHours() {
      if (this.jobTypes.length === 0) {
        this.toastr.clear();
        this.toastr.error("Please Add Job type.");
        return;
      }
      let hasNullDate = this.f.value.hours.some(
        (item) => item.startTime === null
      );
      let hasNullEndDate = this.f.value.hours.some(
        (item) => item.endTime === null
      );
      const hasNullJobType = this.f.value.hours.some(
        (item) => item.jobType === null || item.jobType === ""
      );
      const hasEqualTime = this.f.value.hours.some(
        (item) => item.startTime === item.endTime
      );


      if (!hasEqualTime) {
        this.hasStartNullDateError =
          "";
        return;
      }

      // if (hasEqualTime) {
      //   this.hasStartNullDateError =
      //     "Start time and End time should not be equal.";
      //   return;
      // }

      if (hasNullDate) {
        this.hasStartNullDateError = "Please enter start time.";
        return;
      }

      if (hasNullJobType) {
        this.hasJobTypeNullError = "Please select job type.";
        return;
      }

      if(hasNullEndDate){
        this.hasEndNullDateError= "Please enter end time.";
        return;
      }

      let hasNullJobTypeDate = this.f.value.hours.some(
        (item) => item.jobType === null
      );


    }
    onStartTimeChange(event: any, i, endTimeValue) {
      // if(this.restaurantSettings[11].settingValue !== "Next Day"){
        this.hasStartNullDateError = "";
        // this.hasBothDateNullError = "";
        // should use uuid

        // if (!endTimeValue) {
        //   return;
        // }

        const startTimeValue = event.target.value;

        // const startDate = new Date()
        // const endDate = new Date()
        const [startH, startM] = startTimeValue?.split(":") || ["00", "00"];
        // startDate.setHours(+startH)
        // startDate.setMinutes(+startM)

        const [endH, endM] = endTimeValue?.split(":") || ["23", "59"];
        // endDate.setHours(+endH)
        // endDate.setMinutes(+endM)

        let startTime = this.timezoneService
          .get()()
          .startOf("day")
          .add(+startH, "hours")
          .add(+startM, "minutes")
          .unix();

        let endTime = this.timezoneService
          .get()()
          .startOf("day")
          .add(+endH, "hours")
          .add(+endM, "minutes")
          .unix();
       // Calculate the difference in hours and minutes
       if (endTime < startTime) {
        endTime += 24 * 60 * 60; // Add a day in seconds
        console.log("endTime", endTime);
        console.log("END TIME LESS THAN START TIME")
      }

      // Calculate the difference in hours and minutes
      const diffInMinutes = (endTime - startTime) / 60;
      const hours = Math.floor(diffInMinutes / 60);
      const minutes = diffInMinutes % 60;

      // Display the duration
      const duration = `${hours} hr ${minutes} m`;
      this.timeAndHourDuration = duration

      console.log('timeAndHourDuration',this.timeAndHourDuration);
      this.hoursFormArray.at(i).patchValue({
            hours:this.timeAndHourDuration,
          });

        // const startTime = parseInt((startDate.getTime() / 1000).toString())
        // const endTime = parseInt((endDate.getTime() / 1000).toString())


        this.hoursFormArray.updateValueAndValidity();
        // No need for Validation because of nextDay Implementation
        // if (this.hasOverlap(this.f.value.hours) && this.startTimeLessError === "") {
        //   this.overLapError =
        //     "Your Working Hours should not overlap and be in order.";
        // } else {
        //   this.overLapError = "";
        // }
        this.validateHours()
      // }


    }

    onEndTimeChange(event: any, i, startTimeValue) {

      // if(this.restaurantSettings[11].settingValue !== "Next Day"){
        this.validateHours()
        const endTimeValue = event.target.value;
        if (!startTimeValue) {
          return;
        }
        // const startDate = new Date()
        // const endDate = new Date()

        const [startH, startM] = startTimeValue.split(":");
        // startDate.setHours(+startH)
        // startDate.setMinutes(+startM)

        const [endH, endM] = endTimeValue.split(":");
        // endDate.setHours(+endH)
        // endDate.setMinutes(+endM)

        // const startTime = parseInt((startDate.getTime() / 1000).toString())
        // const endTime = parseInt((endDate.getTime() / 1000).toString())

        let startTime = this.timezoneService
          .get()()
          .startOf("day")
          .add(+startH, "hours")
          .add(+startM, "minutes")
          .unix();

        let endTime = this.timezoneService
          .get()()
          .startOf("day")
          .add(+endH, "hours")
          .add(+endM, "minutes")
          .unix();

           // Calculate the difference in hours and minutes
           if (endTime < startTime) {
            endTime += 24 * 60 * 60; // Add a day in seconds
          }

          // Calculate the difference in hours and minutes
          const diffInMinutes = (endTime - startTime) / 60;
          const hours = Math.floor(diffInMinutes / 60);
          const minutes = diffInMinutes % 60;

          // Display the duration
          const duration = `${hours} hr ${minutes} m`;
          this.timeAndHourDuration = duration

          console.log('timeAndHourDuration',this.timeAndHourDuration);
          this.hoursFormArray.at(i).patchValue({
                hours:this.timeAndHourDuration,
              });

        // if (startTimeValue && endTimeValue && !(endTime < startTime)) {
        //   this.startTimeLessError = "";
        //   this.hoursFormArray.at(i).patchValue({
        //     hours: this.formatHHMMTime(endTime - startTime, 1),
        //   });
        // } else {
        //   this.startTimeLessError = "Start time should be less than end time.";
        //   this.hoursFormArray.at(i).patchValue({
        //     hours: "0h 0m",
        //   });
        // }
        this.hoursFormArray.updateValueAndValidity();
        // No need for Validation because of nextDay Implementation
      //   if (this.hasOverlap(this.f.value.hours) && this.startTimeLessError === "") {
      //     this.overLapError =
      //       "Your Working Hours should not overlap and be in order.";
      //   } else {
      //     this.overLapError = "";
      //   // }

      // }
      // this.hasBothDateNullError = "";
      // this.hasEndNullDateError = "";
      // should use uuid
       }



    hasOverlap(arr) {
      arr.sort((a, b) => a.startTime - b.startTime);
      // for (let i = 0; i < arr.length - 1; i++) {
      //   if (arr[i].endTime >= arr[i + 1].startTime) {
      //     return true;
      //   }
      // }
      for (let i = 0; i < arr.length; i++) {
        // Compare if the endTime is less than or equal to the startTime of the object
        if (arr[i].endTime <= arr[i].startTime) {
          return true;
        }
      }
      return false;
    }

    onSelect(e) {
      this.hasJobTypeNullError = "";
    }

    formatTime(time) {
      if (!time) {
        return "";
      }

      return this.timezoneService.get()(time, "hh:mm A").format("HH:mm");
    }

    addNewHour() {
      this.hoursCount += 1;
      this.hoursFormArray.push(
        this.fb.group({
          startTime: [null, [Validators.required]],
          endTime: [null, [Validators.required]],
          jobType: [null, [Validators.required]],
          workingHourId: [""],
          hours: ["0h 0m"],
          status: [1],
        })
      );
    }

    // delete modifier option
    onDeleteHour(index: number) {
      this.hoursCount -= 1;
      this.hoursFormArray.at(index).patchValue({
        status: 0,
      });
      (this.hoursFormArray.at(index) as FormGroup).controls[
        "startTime"
      ].clearValidators();
      (this.hoursFormArray.at(index) as FormGroup).controls[
        "endTime"
      ].clearValidators();
      (this.hoursFormArray.at(index) as FormGroup).controls[
        "jobType"
      ].clearValidators();
      (this.hoursFormArray.at(index) as FormGroup).controls[
        "startTime"
      ].updateValueAndValidity();
      (this.hoursFormArray.at(index) as FormGroup).controls[
        "endTime"
      ].updateValueAndValidity();
      (this.hoursFormArray.at(index) as FormGroup).controls[
        "jobType"
      ].updateValueAndValidity();
      this.hoursFormArray.updateValueAndValidity();

      // Clear All the Error Messages
      this.hasStartNullDateError = "";
      this.hasEndNullDateError = "";
      // hasBothDateNullError = "";
      this.hasJobTypeNullError = "";
      this.startTimeLessError = "";
      this.overLapError = "";
    }

    hasStartNullDateError = "";
    hasEndNullDateError = "";
    // hasBothDateNullError = "";
    hasJobTypeNullError = "";
    startTimeLessError = "";
    overLapError = "";
    onSubmit() {
      const storeId = this.cookieService.get("storeId");

      if (storeId === "*") {
        this.toastr.clear();
        this.toastr.error("Please select a location first.");
        return;
      }
      if(this.restaurantSettings[11].settingValue !== "Next Day"){
        if (this.jobTypes.length === 0) {
          this.toastr.clear();
          this.toastr.error("Please Add Job type.");
          return;
        }
        let hasNullDate = this.f.value.hours.some(
          (item) => item.startTime === null
        );
        let hasNullEndDate = this.f.value.hours.some(
          (item) => item.endTime === null
        );
        const hasNullJobType = this.f.value.hours.some(
          (item) => item.jobType === null || item.jobType === ""
        );
        const hasEqualTime = this.f.value.hours.some(
          (item) => item.startTime === item.endTime
        );

        // if(hasNullDate && hasNullEndDate){
        //   this.hasBothDateNullError= "Start time/End time is mandatory.";
        //   return;
        // }


        if (hasNullDate) {
          this.hasStartNullDateError = "Please enter start time.";
          return;
        }

        if (hasEqualTime) {
          this.hasStartNullDateError =
            "Start time and End time should not be equal.";
          return;
        }
        if(hasNullEndDate){
          this.hasEndNullDateError= "Please enter end time.";
          return;
        }
        if (hasNullJobType) {
          this.hasJobTypeNullError = "Please select job type.";
          return;
        }


        let hasNullJobTypeDate = this.f.value.hours.some(
          (item) => item.jobType === null
        );

        if (hasNullJobTypeDate) {
          this.hasJobTypeNullError = "Please select job type.";
          return;
        }

        if (
          this.hasStartNullDateError !== "" ||
          this.startTimeLessError !== "" ||
          this.overLapError !== ""
        ) {
          return;
        }

        // console.log("===",this.f.valid);
        // if (!this.f.valid) {
        //   this.f.markAllAsTouched();
        //   return;
        // }

        // if (!this.isLessThanEndTime) {
        //   this.toastr.clear();
        //   this.toastr.error(
        //     "Your Working Hours should not overlap and be in order."
        //   );
        //   return;
        // }
      }

      const workingHours = this.f.value.hours.map((h) => {
        // const startDate = new Date(this.today)
        // const endDate = new Date(this.today)

        const [startH, startM] = h.startTime.split(":");
        // startDate.setHours(startH)
        // startDate.setMinutes(startM)
        const empWorkHrsDateFilter = localStorage.getItem(
          "employeeWorkingHoursDateFilter"
        );
        let startTimeUnix: any;
        if (empWorkHrsDateFilter) {
          startTimeUnix = this.timezoneService
            .get()(empWorkHrsDateFilter)
            .startOf("day")
            .add(+startH, "hours")
            .add(+startM, "minutes")
            .unix();
        } else {
          startTimeUnix = this.timezoneService
            .get()()
            .startOf("day")
            .add(+startH, "hours")
            .add(+startM, "minutes")
            .unix();
        }
        let startTime = startTimeUnix;
        const jobObj = this.jobTypes.find((val) => val.jobtypeId === h.jobType);
        console.log("JOB OBJ", jobObj);
        if (h.endTime) {
          console.log("IFFF")
          const [endH, endM] = h.endTime?.split(":");
          // endDate.setHours(endH)
          // endDate.setMinutes(endM)
          let endTime = this.timezoneService
            .get()()
            .startOf("day")
            .add(+endH, "hours")
            .add(+endM, "minutes")
            .unix();
          // set end time to that day's selection as past day time worked hour has issues
          if (empWorkHrsDateFilter) {
            endTime = this.timezoneService
              .get()(empWorkHrsDateFilter)
              .startOf("day")
              .add(+endH, "hours")
              .add(+endM, "minutes")
              .unix();
          }

          console.log("JOB OBJ", jobObj);

          return {
            // startDate: parseInt((startDate.getTime() / 1000).toString()),
            // endDate: parseInt((endDate.getTime() / 1000).toString()),
            startDate: startTime,
            endDate: endTime,
            employeeJobtypeId: jobObj?.jobtypeId || null,
            employeeJobtypeName: jobObj?.jobtypeName || "",
            employeeJobtypeCode: this.selectedEmployee.employeeJobtypeCode || "",
            employeeRate: jobObj?.jobtypeRate,
              // this.selectedEmployee.employeeWorkingHours?.workingHours.at(-1)
              //   .employeeRate,
            // employeeOvertimeRate:
            //   this.selectedEmployee.employeeWorkingHours?.workingHours.at(-1)
            //     .employeeOvertimeRate,
            employeeOvertimeRate: jobObj?.jobtypeOvertimeRate,
            employeeDoubleTimeRate: jobObj?.jobtypeDoubleRate,
              // this.selectedEmployee.employeeWorkingHours?.workingHours.at(-1)
              //   .employeeDoubleTimeRate,
            employeeId: this.selectedEmployee.employeeId,
            employeeBaseRate: jobObj?.jobtypeRate,
            employeeDoubeRate: jobObj?.jobtypeDoubleRate,
            workingHourId: h.workingHourId,
            status: h.status,
          };
        } else {
          console.log("ELSEEE")
          return {
            startDate: startTimeUnix,
            endDate: -1,
            employeeJobtypeId: jobObj?.jobtypeId || null,
            employeeJobtypeName: jobObj?.jobtypeName || "",
            employeeJobtypeCode: this.selectedEmployee.employeeJobtypeCode || "",
            employeeRate:
              this.selectedEmployee.employeeWorkingHours?.workingHours.at(-1)
                .employeeRate,
            // employeeOvertimeRate: jobObj?.employeeJobtypeRate,
            employeeOvertimeRate: jobObj?.jobtypeOvertimeRate,
            employeeDoubleTimeRate:
              this.selectedEmployee.employeeWorkingHours?.workingHours.at(-1)
                .employeeDoubleTimeRate,
            employeeId: this.selectedEmployee.employeeId,
            employeeBaseRate: jobObj?.jobtypeRate,
            employeeDoubeRate: jobObj?.jobtypeDoubleRate,
            workingHourId: h.workingHourId,
            status: h.status,
          };
        }
      });

      const payload = {
        workingHours:workingHours,
        storeId: storeId,
        // employeeJobtypeId :null
      };

      console.log("PAYLOAD", payload);
      // const payload = {
      //   ...workingHours[0],
      //   storeId: storeId,
      //   employeeJobtypeId :null
      // };
      this.isLoading = true;
      this.employeeListService.updateWorkingHour(payload).subscribe(
        (response: any) => {
          if (response.success === 0) {
            this.isLoading = false;
            this.toastr.clear();
            this.toastr.error(response.message);
          } else {
            this.isLoading = false;
            this.toastr.clear();
            this.toastr.success(response.message);
            this.modalService.dismissAll();
            setTimeout(() => {
              this.reload();
            }, 3000);        }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error);
          this.isLoading = false;
          this.toastr.clear();
          this.toastr.error(message);
        }
      );
    }


    get addShiftFormValues() {
      return this.addShiftForm.controls;
    }

    payloadObjectArr = [];
    newPayloadDaysObj: any;
    onSubmitAddShift() {
      // this.addShiftForm.markAllAsTouched();
      if (!this.addShiftForm.valid) {
        this.addShiftForm.markAllAsTouched();
        return;
      }
      this.isLoading = !this.isLoading;
      console.log("this.addShiftForm.value", this.addShiftForm.value);
      console.log("this.addShiftForm.controls", this.addShiftForm.controls);
      if (this.addShiftForm.valid) {
        // this.addShiftForm.controls.startDate.setValue(Math.floor(new Date(this.addShiftForm.controls.startDate.value).getTime() / 1000))
        // this.addShiftForm.controls.endDate.setValue(Math.floor(new Date(this.addShiftForm.controls.endDate.value).getTime() / 1000))
        // if (this.addShiftForm.controls.startDate.value > this.addShiftForm.controls.endDate.value) {
        //   this.addShiftForm.controls.startDate.setErrors({ notUnique: true})
        //   this.addShiftForm.controls.endDate.setErrors({ notUnique: true})
        //   this.isLoading = !this.isLoading
        //   return
        // }
        // console.log("OBJ: ", this.formatTimeStartEnd());
        this.isValidTimeStartTime = this.startTime === "00:00" ? false : true;
        this.isValidTimeEndTime = this.endTime === "00:00" ? false : true;
        const startTimeArr = this.startTime.split(":");
        const endTimeArr = this.endTime.split(":");
        const startHours = Number(startTimeArr[0]);
        const endHours = Number(endTimeArr[0]);
        const startMinutes = Number(startTimeArr[1]);
        const endMinutes = Number(endTimeArr[1]);
        console.log("startHours: ", startHours);
        console.log("endHours: ", endHours);
        console.log("startMinutes: ", startMinutes);
        console.log("endMinutes: ", endMinutes);
        if (this.startTime === this.endTime) {
          this.isValidTimeStartTime = false;
          this.isValidTimeEndTime = false;
          this.isLoading = false;
          return;
        } else {
          if (
            (startHours > endHours ||
              (startHours == endHours && startMinutes > endMinutes)) &&
            !this.addShiftFormValues.nextDay.value
          ) {
            console.log("this.addShiftFormValues", this.addShiftFormValues);
            console.log("TIME_ERROR_COMING");
            this.isValidTimeStartTime = false;
            this.isValidTimeEndTime = false;
            this.isLoading = false;
            return;
          } else {
            this.isValidTimeStartTime = true;
            this.isValidTimeEndTime = true;
          }
        }
        if (this.startTime)
          this.addShiftForm.controls.startDate.setValue(
            parseInt(
              this.timezoneService
                .get()(
                  this.addShiftForm.controls.startDate.value +
                  " " +
                  this.startTime
                )
                .format("X")
            )
          );
        this.addShiftForm.controls.endDate.setValue(
          parseInt(
            this.timezoneService
              .get()(
                this.addShiftForm.controls.endDate.value + " " + this.endTime
              )
              .format("X")
          )
        );
        if (
          this.addShiftForm.controls.startDate.value >=
          this.addShiftForm.controls.endDate.value
        ) {
          this.addShiftForm.controls.startDate.setErrors({ notUnique: true });
          this.addShiftForm.controls.endDate.setErrors({ notUnique: true });
          this.isLoading = !this.isLoading;
          return;
        }
        // console.log("this.addShiftFormValues.days", this.addShiftFormValues.days);

        // if(this.addShiftFormValues.nextDay) {
        if (this.addShiftForm.controls.days.value) {
          console.log(
            "this.addShiftForm.controls.days.value",
            this.addShiftForm.controls.days.value
          );

          this.addShiftForm.controls.days.setValue(
            [...this.addShiftForm.controls.days.value].map((data) => {
              return data?.item_id;
            })
          );
          // }
        } else {
        }

        if (
          this.addShiftForm.controls.startDate.value >=
          this.addShiftForm.controls.endDate.value
        ) {
          // this.addShiftForm.controls.startDate.setErrors({ notUnique: true });
          // this.addShiftForm.controls.endDate.setErrors({ notUnique: true });
          this.isValidTimeEndTime = false;
          this.isLoading = !this.isLoading;
          return;
        }
        let obj: any = this.formatTimeStartEnd();
        console.log("OBJ_SCHEDULE_DAYS", obj);

        // Create an array to store the new 'days' structure
        if (obj.days != null && obj.days != undefined) {
          // const newDays = obj?.days?.map(dayName => {
          this.newPayloadDaysObj = obj?.days.map((dayName) => {
            return {
              day: dayName,
              startTime: this.startTime,
              endTime: this.endTime,
              isChecked: this.addShiftFormValues.recurring.value,
              nextDay: this.addShiftFormValues.nextDay.value,
            };
          });
          if (obj.recurring && obj.nextDay) {
            for (let j = 0; j < this.newPayloadDaysObj.length; j++) {
              if (this.newPayloadDaysObj[j]?.nextDay) {
                let endTimeValue = (this.newPayloadDaysObj[j].endTime =
                  this.timezoneService
                    .get()(this.newPayloadDaysObj[j].endTime, "HH:mm")
                    .format("HH:mm"));
                console.log("endTimeValue", endTimeValue);
                this.newPayloadDaysObj[j].endTime = this.timezoneService
                  .get()(this.newPayloadDaysObj[j].endTime, "HH:mm")
                  .endOf("day")
                  .format("HH:mm");
                this.newPayloadDaysObj.push({
                  day: this.newPayloadDaysObj[j].day,
                  startTime: this.timezoneService
                    .get()(this.newPayloadDaysObj[j].startTime, "HH:mm")
                    .startOf("day")
                    .format("HH:mm"),
                  endTime: endTimeValue,
                  isChecked: this.newPayloadDaysObj[j].isChecked,
                });
              }
            }
          }

          // Update the payload with the new 'days' structure
          obj.days = this.newPayloadDaysObj;
          // change the 'obj.days' to 'obj.activeDays' to match the API
          obj.activeDays = obj.days;
          delete obj.days;
        }

        // this.payloadObjectArr.push(obj);
        // console.log("this.payloadObjectArr", this.payloadObjectArr)
        //   for(let j = 0; j < this.payloadObjectArr.length; j++){
        //     if(this.payloadObjectArr[j]?.recurring && this.payloadObjectArr[j]?.nextDay) {
        //       for(let i = 0; i < this.payloadObjectArr[j].days.length; i++){
        //           let endTimeValue = this.payloadObjectArr[j].days[i].endTime = this.timezoneService
        //           .get()(this.payloadObjectArr[j].days[i].endTime, "hh:mm a")
        //           .format("hh:mm a");;
        //           console.log("endTimeValue", endTimeValue)
        //           this.payloadObjectArr[j].days[i].endTime = this.timezoneService
        //           .get()(this.payloadObjectArr[j].days[i].endTime, "hh:mm a")
        //           .endOf('day')
        //           .format("hh:mm a");
        //           this.payloadObjectArr[j].days.push({
        //             day: this.payloadObjectArr[j].days[i].day,
        //             startTime: this.timezoneService
        //             .get()(this.payloadObjectArr[j].days[i].startTime, "hh:mm a")
        //             .startOf('day')
        //             .format("hh:mm a"),
        //             endTime: endTimeValue,
        //             recurring: this.payloadObjectArr[j].days[i].recurring,
        //           })
        //       }
        //       }
        //     }

        console.log("OBJ: AFTER", obj);
        // this.employeeListService
        //   .updateEmployeeSchedule({ ...obj, storeId: this.storeId })
        //   .subscribe(
        //     (response: any) => {
        //       if (response.success == 0) {
        //         this.toastr.error(response.message);
        //       } else {
        //         console.log(response)
        //         this.toastr.success(response.message);
        //         this.calendarEvents = [];
        //         // this.addShiftModalRef.dismiss();
        //         this.modalService.dismissAll();
        //         this.calendarOptions.events = [];
        //         let employeeId = this.addShiftForm.controls.employeeId.value;
        //         this.addShiftForm.reset();
        //         this.addShiftForm.controls.employeeId.setValue(employeeId);
        //         this.addShiftForm.controls.status.setValue(1);
        //         this.addShiftForm.controls.employeeScheduleType.setValue(7);
        //         this.addShiftForm.controls.employeeScheduleNotes.setValue("");
        //         this.rangestartDate = this.timezoneService
        //           .get()()
        //           .startOf("week")
        //           .add("day", 1);
        //         this.rangeendDate = this.timezoneService
        //           .get()()
        //           .endOf("week")
        //           .add("day", 1);
        //         this.rangestartDateDisplay =
        //           this.rangestartDate.format("MM/DD/YYYY");
        //         this.rangeendDateDisplay = this.rangeendDate.format("MM/DD/YYYY");
        //         this.startdateFormatted = new Date();
        //         this.addShiftForm.controls.startDate.setValue(
        //           this.timezoneService
        //             .get()(this.rangestartDate)
        //             .unix()
        //             .toString()
        //         );
        //         this.addShiftForm.controls.endDate.setValue(
        //           this.timezoneService.get()(this.rangeendDate).unix().toString()
        //         );
        //         this.getEmployeeSchedule(
        //           this.addShiftForm.controls.employeeId.value
        //         );
        //       }
        //       this.isLoading = !this.isLoading;
        //     },
        //     (error) => {
        //       this.isLoading = !this.isLoading;
        //       const message = this.ApiService.errorMessage(error);
        //       this.toastr.error(message);
        //     }
        //   );
      } else {
        this.isLoading = !this.isLoading;
        this.isValidTimeStartTime = this.startTime === "00:00" ? false : true;
        this.isValidTimeEndTime = this.endTime === "00:00" ? false : true;
      }
    }
    formatTimeStartEnd = () : any => {
      const Timezone = this.timezoneService.get()

      let obj = {
        ...this.addShiftForm.value,
      };

      const SD = Timezone(this.addShiftForm.value.startDate * 1000).format('YYYY-MM-DD')
      const ED = Timezone(this.addShiftForm.value.endDate * 1000).format('YYYY-MM-DD')

      obj["startDate"] = parseInt(Timezone(SD + " " + this.startTime).format("X"))
      obj["endDate"] = parseInt(Timezone(ED + " " + this.endTime).format("X"))

      return obj;
    }
    onSelectEmployeeFile(event) {
      this.employeeFiles = [];
      this.progress = 0;

      if (!event.addedFiles.length) {
        return;
      }

      this.employeeFiles.push(...event.addedFiles);
    }

    onRemoveEmployeeFile(event) {
      this.progress = 0;

      this.employeeFiles.splice(this.employeeFiles.indexOf(event), 1);
    }

    uploadEmployeeFile() {
      if (!this.employeeFiles.length) {
        return;
      }

      this.showUploadEmployeeProgress = true;
      this.isLoadingUploadeEmployee = true;

      const formData = new FormData();
      formData.append("file", this.employeeFiles[0]);
      console.log("formData-UPLOADED_FILE", formData);
      this.employeeListService.uploadEmployee(formData).subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.Sent:
              console.log("Request has been made!");
              break;
            case HttpEventType.ResponseHeader:
              console.log("Response header has been received!");
              break;
            case HttpEventType.UploadProgress:
              this.progress = Math.round((event.loaded / event.total) * 100);
              console.log(`Uploaded! ${this.progress}%`);
              break;
            case HttpEventType.Response:
              console.log("Employee successfully imported!", event.body);
              const response = event.body;
              if (response.success) {
                if (
                  response.response?.deptError.length ||
                  response.response?.employeeError.length ||
                  response.response?.jobTypeError.length
                ) {
                  const deptError = response.response?.deptError || [];
                  const employeeError = response.response?.employeeError || [];
                  const jobTypeError = response.response?.jobTypeError || [];
                  let errMessage = "";

                  deptError.forEach((err) => {
                    errMessage = errMessage + " " + err.error[0].message;
                  });
                  employeeError.forEach((err) => {
                    errMessage = errMessage + " " + err.error[0].message;
                  });
                  jobTypeError.forEach((err) => {
                    errMessage = errMessage + " " + err.error[0].message;
                  });
                  this.toastr.error(errMessage);
                  // this.toastr.error("Invalid imported employee list.");
                  this.isLoadingUploadeEmployee = false;
                  this.progress = 0;
                } else if (response.response.valid.length) {
                  this.toastr.success(response.message);
                  this.addEmployee(response.response.valid);
                } else {
                  this.toastr.error("An unknown error occured.");
                  this.isLoadingUploadeEmployee = false;
                  this.progress = 0;
                }
              } else {
                this.toastr.error(response.message);
                this.isLoadingUploadeEmployee = false;
                this.progress = 0;
              }

              break;
            default:
              break;
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
          this.isLoadingUploadeEmployee = false;
        }
      );
    }

    resetImportEmployee() {
      this.employeeFiles = [];
      this.progress = 0;
      this.showUploadEmployeeProgress = false;
      this.isUploadEmployeeDone = false;
    }

    addEmployee(employees) {
      if (this.storeId === "*" || this.storeId === undefined) {
        this.toastr.error("Please select a location first.");
        return;
      }

      const transformedEmployees = employees.map((emp) => {
        return {
          firstName: emp.Firstname,
          isUser: emp.Access.toLowerCase() == "yes",
          lastName: emp.Lastname,
          mobile: emp.Phone,
          pincode: emp.Pin.toString(),
          roleId: emp?.roleId,
          storeId: this.storeId,
          username: emp.Email,
        };
      });

      const payload = {
        employeeList: transformedEmployees,
      };

      this.employeeListService.addEmployee(payload).subscribe(
        (response: any) => {
          if (response.success) {
            this.toastr.success(response.message);
            this.modalService.dismissAll();
            this.isLoadingUploadeEmployee = false;
            this.resetImportEmployee();
            this.refreshDataTable();
          } else {
            this.toastr.error(response.message);
            this.isLoadingUploadeEmployee = false;
            this.progress = 0;
          }
        },

        (error) => {
          const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
          this.isLoadingUploadeEmployee = false;
          this.progress = 0;
        }
      );
    }

    changeStore(event: any) {
      this.params = new HttpParams();
      this.storeId = event;
      this.store.dispatch(setLoadingSpinner({ status: true }));
      if (event !== "*") {
        this.params = this.params.set("storeId", this.storeId);
        this.httpOptions = {
          headers: new HttpHeaders(this.headerToken),
          params: this.params,
        };

        this.refreshDataTable();
      } else {
        this.httpOptions = { headers: new HttpHeaders(this.headerToken) };

        this.refreshDataTable();
      }
    }

    goToAddPage() {
      if (this.storeId == "*" || this.storeId == undefined) {
        this.toastr.error("Please select a location first.");
        return;
      }

      this.router.navigate(["/employees/add-employee"]);
    }

    ngOnDestroy() {
      if (this.dataSubscription) this.dataSubscription.unsubscribe();
    }

    convertDate(timeStamp: number) {
      if (timeStamp) {
        return this.timezoneService
          .get()(timeStamp * 1000)
          .format("D-MMM-YYY");
      } else {
        return "";
      }
    }

    convertTime(timeStamp: number) {
      if (timeStamp) {
        return this.timezoneService.get().unix(timeStamp).format("h:mm A");
      } else {
        return "";
      }
    }

    RemoveUnwantedClass() {
      this.renderer.removeClass(document.body, "modal-open");
    }

    /**
     * Handles the mouse enter event for the employee name.
     * Positions the tooltip element relative to the target element.
     *
     * @param event - The mouse enter event.
     */
    employeeNameMouseEnter(event: any) {
      const target = event.target as HTMLElement;
      const rect = target.getBoundingClientRect();
      const { top, left } = rect;

      const tooltip = target.querySelector(".employee-tooltip");

      this.renderer.setStyle(tooltip, "position", "fixed");
      this.renderer.setStyle(tooltip, "top", `${top + tooltip.clientHeight}px`);
      this.renderer.setStyle(tooltip, "left", `${left + tooltip.clientWidth / 2}px`);
    }
    updateTicket(id: string) {
      if (this.storeId === "*") {
        this.toastr.clear();
        this.toastr.error("Please select a location first.");
        return;
      }
  
      this.router.navigate(["./update", id], { relativeTo: this.route });
    }

}
